export default {
  title: 'Aide et FAQ',
  buttons: {
    faqs: 'FAQ',
    contact_us: 'Nous contacter',
  },
};
